import React, { useEffect, useRef, useState } from "react";
import Zoom from "@mui/material/Zoom";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  FormControlLabel,
  FormGroup,
  IconButton,
  ListItemText,
  Popper,
  Switch,
  TextField,
  Tooltip,
  Typography,
  tooltipClasses,
} from "@mui/material";
import { useNavigate } from "react-router";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import styled from "@emotion/styled";
import Cookies from "js-cookie";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { Alert, Divider, Modal, Skeleton, Snackbar } from "@mui/material";
import { useSelector } from "react-redux";
import { generate_filter_condition } from "../utiles/filter";
import SearchCandidate from "./searchCandidate";
import CandidateDetails from "../components/candidateDetails";

const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 500,
    backgroundColor: "#fff",
    color: "#000",
    border: "1px solid #e0e0e0",
    boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: "#fff",
    "&::before": { border: "1px solid #e0e0e0" },
  },
});

// ── KEY: All input boxes share the EXACT same fixed height ─────────────────
// Chips scroll horizontally inside — height never changes
const FIELD_HEIGHT = 40;

const inputBoxSx = {
  display: "flex",
  alignItems: "center",
  border: "1px solid #d0d5dd",
  borderRadius: "8px",
  height: `${FIELD_HEIGHT}px`, // ← FIXED height, never grows
  overflow: "hidden", // ← chips won't push height
  backgroundColor: "#fff",
  px: "10px",
  boxSizing: "border-box",
};

const uncheckedIcon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
const dropdownIconSx = { fontSize: "20px", color: "#667085" };

// ── Shared sx for every Autocomplete inside a fixed-height box ────────────
const autocompleteInputRootSx = {
  flexWrap: "nowrap !important", // ← chips stay on ONE line
  overflowX: "auto",
  overflowY: "hidden",
  scrollbarWidth: "none",
  p: "0 !important",
  "&::-webkit-scrollbar": { display: "none" }, // hide scrollbar Chrome
  fontSize: "13px",
  gap: "4px",
};

const autocompleteSx = {
  width: "100%",
  "& .MuiAutocomplete-endAdornment": { display: "none" },
  // The input wrapper must clip and scroll horizontally, not grow vertically
  "& .MuiInputBase-root": autocompleteInputRootSx,
};

const dropdownAutocompleteSx = {
  width: "100%",
  "& .MuiInputBase-root": {
    ...autocompleteInputRootSx,
    pr: "24px !important",
  },
  "& .MuiAutocomplete-endAdornment": {
    display: "flex",
    right: "0px",
    top: "50%",
    transform: "translateY(-50%)",
  },
  "& .MuiAutocomplete-popupIndicator": {
    color: "#667085",
    p: "2px",
    mr: "-4px",
  },
  "& .MuiAutocomplete-popupIndicatorOpen": {
    transform: "rotate(180deg)",
  },
};

const CreatedByPopper = (props) => {
  const modifiers = [
    ...(props.modifiers || []),
    { name: "offset", options: { offset: [0, 16] } },
  ];

  return <Popper {...props} modifiers={modifiers} />;
};

const FindTalent = () => {
  const nav = useNavigate();
  const PermissionStatus = useSelector((state) => state.user.permissions);
  const addCandidatePermission = PermissionStatus?.["100"];
  const [searchParams, setSearchParams] = useSearchParams();

  const [value, setValue] = useState([]);
  const [isBooleanSearch, setIsBooleanSearch] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [minimum, setminimum] = useState("");
  const [maximum, setmaximum] = useState("");
  const [getprefered, setprefcityLoc] = useState([]);
  const [preferredLocation, setpreferedLocation] = useState([]);
  const [preferredArr, setPreferredArr] = useState([]);
  const [loading, setLoading] = useState(false);
  const [prevoiusserachdata, setprevoiusserachdata] = useState([]);
  const [ExpError2, setExpError2] = useState("");
  const [ExpError, setExpError] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [candidateList, setcandidateList] = useState([]);

  const [hasSearched, setHasSearched] = useState(false);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [searchdata, setsearchdata] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [showLoader, setShowLoader] = useState(false);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [pageNumber, setPageNumber] = useState(1);
  const [queryOptions, setQueryOptions] = useState({});
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [isApplicanOpen, setApplicanOpen] = useState(false);
  const [tableSearch, setTableSearch] = useState("");
  const [addToJobOpen, setAddToJobOpen] = useState(false);
  const [addToJobCandidateSelection, setAddToJobCandidateSelection] = useState(
    [],
  );
  const [jobOrder, setJobOrder] = useState("");
  const [inputValueJobOrder, setInputValueJobOrder] = useState("");
  const [jobOrderOptions, setJobOrderOptions] = useState([]);
  const [joborderIds, setJoborderIds] = useState();
  const [bulkdata, setbulkdata] = useState([]);
  const [adddisbale, setadddisable] = useState(false);
  const [shimmer, setshimmer] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [warning, setwarning] = useState(false);
  const lastPayload = useRef(null);
  const [currentPayload, setCurrentPayload] = useState(null);

  const isSearchEnabled =
    value.length > 0 ||
    minimum !== "" ||
    maximum !== "" ||
    preferredArr.length > 0 ||
    selectedOptions.length > 0;

  const hasAnyValue =
    value.length > 0 ||
    inputValue !== "" ||
    minimum !== "" ||
    maximum !== "" ||
    preferredArr.length > 0 ||
    selectedOptions.length > 0;

  useEffect(() => {
    axios
      .get("all-jobs", {
        headers: {
          authorization:
            Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
        },
      })
      .then((res) => setJobOrderOptions(res?.data?.message || []))
      .catch((err) => console.error("Error fetching jobs:", err));
  }, []);

  const handleAddToJob = () => {
    setAddToJobOpen(true);
    setadddisable(false);
    setbulkdata([]);
  };

  const handleCloseAddToJob = () => {
    setAddToJobOpen(false);
    setJobOrder("");
    setInputValueJobOrder("");
    setadddisable(false);
    setbulkdata([]);
  };

  const handleRowSelectionChange = (newSelection) => {
    const deselectedRows = addToJobCandidateSelection.filter(
      (rowId) => !newSelection.includes(rowId),
    );
    const currentSelectionCount =
      addToJobCandidateSelection.length - deselectedRows.length;
    const validNewSelections = newSelection.filter(
      (id) => !addToJobCandidateSelection.includes(id),
    );
    const canSelectMore = 10 - currentSelectionCount;
    const limitedNewSelections = validNewSelections.slice(0, canSelectMore);
    const updatedSelection = [
      ...addToJobCandidateSelection.filter(
        (id) => !deselectedRows.includes(id),
      ),
      ...limitedNewSelections,
    ];
    if (validNewSelections.length > limitedNewSelections.length)
      setwarning(true);
    else setwarning(false);
    setAddToJobCandidateSelection(updatedSelection);
  };

  const handleAddCandidates = () => {
    axios
      .post(
        "bulk-add/job",
        {
          candidate_ids: addToJobCandidateSelection || [],
          job_id: joborderIds || "",
          quesAnsArray: [],
          isShortlisted: 0,
        },
        {
          headers: {
            authorization:
              Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
          },
        },
      )
      .then((res) => {
        if (res.status === 200) {
          setAddToJobCandidateSelection([]);
          setJobOrder("");
          setshimmer(false);
          setbulkdata(res.data.message.details);
          if (res.data.message.failure_candidates >= 1) setadddisable(true);
          setSnackbarMessage("Candidate Added Successfully");
          setOpenSnackbar(true);
          if (res.data.message.failure_candidates === 0) setAddToJobOpen(false);
        }
      })
      .catch((err) => {
        console.error("error", err);
        setSnackbarMessage(
          err?.response?.data?.error || "Something went wrong",
        );
        setOpenSnackbar(true);
        setAddToJobOpen(false);
      });
  };

  const getUserData = async () => {
    try {
      const user_id = localStorage.getItem("user_id");
      const res = await axios.get(`active-users/${user_id}`, {
        headers: {
          authorization:
            Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
        },
      });
      setcandidateList(res.data.message);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getUserData();
  }, []);

  const handleminimumexpreience = (e) => {
    const val = e.target.value;
    if (
      val === "" ||
      (/^\d+$/.test(val) &&
        parseInt(val, 10) >= 0 &&
        parseInt(val, 10) <= 40 &&
        parseInt(val, 10).toString() === val)
    ) {
      setminimum(val);
      setExpError2("");
      checkAndClearIfAllEmpty(
        value,
        val,
        maximum,
        preferredArr,
        selectedOptions,
      );
    } else {
      setExpError2("Min experience must be 0–40");
    }
  };

  const handlemaximumexpreience = (e) => {
    const val = e.target.value;
    if (
      val === "" ||
      (/^\d+$/.test(val) && parseInt(val, 10) >= 1 && parseInt(val, 10) <= 40)
    ) {
      setmaximum(val);
      setExpError("");
      checkAndClearIfAllEmpty(
        value,
        minimum,
        val,
        preferredArr,
        selectedOptions,
      );
    } else {
      setExpError("Max experience must be 1–40");
    }
  };

  useEffect(() => {
    const ondata = async () => {
      try {
        const response = await axios.post(
          process.env.REACT_APP_JOBEZEURL + "/state-city/list",
          { search: typeof getprefered === "string" ? getprefered : "" },
        );
        setpreferedLocation(
          (response.data.message || [])
            .filter((item) => item?.valueType === "city")
            .map((item) => ({ ...item, name: item.value })),
        );
      } catch (error) {
        console.error("Error", error);
      }
    };
    ondata();
  }, [getprefered]);

  const fetchPreviousSearchData = () => {
    axios
      .get(`previous-search`, {
        headers: {
          authorization:
            Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
        },
      })
      .then((res) => setprevoiusserachdata(res.data.message))
      .catch((err) =>
        console.error("Error fetching previous search data", err),
      );
  };
  useEffect(() => {
    fetchPreviousSearchData();
  }, []);

  const handleChipClick = (data) => {
    nav(
      `/searchCandidate?id=${data.id}&keywords=${data.keywords}&created_by=${data.created_by ? data.created_by : ""}&min_exp=${data.min_exp ? data.min_exp : ""}&max_exp=${data.max_exp ? data.max_exp : ""}&location=${data.location}&booleanSearch=${data.booleanSearch}&min_salary=${data.min_salary ? data.min_salary : ""}&max_salary=${data.max_salary ? data.max_salary : ""}`,
    );
  };
  // Ek helper function banao
  const checkAndClearIfAllEmpty = (
    updatedValue,
    updatedMin,
    updatedMax,
    updatedLocation,
    updatedSelected,
  ) => {
    const allEmpty =
      updatedValue.length === 0 &&
      updatedMin === "" &&
      updatedMax === "" &&
      updatedLocation.length === 0 &&
      updatedSelected.length === 0;

    if (allEmpty) {
      setIsSearchActive(false);
      setCurrentPayload(null);
      lastPayload.current = null;
    }
  };
  const doSearch = (payload, page) => {
    setHasSearched(true);
    setsearchdata([]);
    setShowLoader(true);
    axios
      .post(`find-talent-new/${page}`, payload, {
        headers: {
          authorization:
            Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
        },
      })
      .then((res) => {
        setsearchdata(res.data.message.search_result);
        setTotalCount(res.data.message.total_search_result);
        setShowLoader(false);
      })
      .catch((err) => {
        console.error(err);
        setShowLoader(false);
      });
  };

  const handleSearchCandidate = () => {
    if (maximum !== "" && Number(maximum) <= Number(minimum)) {
      setExpError("Max experience cannot be ≤ minimum");
      return;
    }
    setExpError("");
    setExpError2("");
    setLoading(true);
    const filteredValue = value.filter((v) => v !== "");
    let createdByName = "";
    if (selectedOptions.length > 0) {
      createdByName = generate_filter_condition(
        `entered_by`,
        "isAnyOf",
        selectedOptions.map((item) => item.name),
      );
    }
    const payload = {
      keywords: isBooleanSearch ? filteredValue.join(",") : filteredValue,
      min_exp: minimum,
      max_exp: maximum,
      min_salary: "",
      max_salary: "",
      location: preferredArr.length > 0 ? preferredArr : [],
      booleanSearch: isBooleanSearch,
      prev_search_id: "",
      filterCriteria: createdByName,
      pageSize: paginationModel.pageSize,
    };
    lastPayload.current = payload;
    setCurrentPayload(payload); 
    setPageNumber(1);
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
    setQueryOptions({});
    setIsSearchActive(true);
    doSearch(payload, 1);
    setLoading(false);
  };

  const handleClearSearch = () => {
    setValue([]);
    setPreferredArr([]);
    setInputValue("");
    setminimum("");
    setmaximum("");
    setIsBooleanSearch(false);
    setExpError("");
    setExpError2("");
    setSelectedOptions([]);
    setIsSearchActive(false);
    setHasSearched(false);
    setsearchdata([]);
    setTotalCount(0);
    lastPayload.current = null;
    setCurrentPayload(null);
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      next.delete("ftSearch");
      return next;
    });
  };

  const handleReset = () => {
    setValue([]);
    setPreferredArr([]);
    setInputValue("");
    setminimum("");
    setmaximum("");
    setIsBooleanSearch(false);
    setExpError("");
    setExpError2("");
    setSelectedOptions([]);
  };

  const hanldePreferredInputChange = (val) => {
    if (val.length > 2) setprefcityLoc(val);
  };

  const handlePaginationChange = (model) => {
    setPaginationModel(model);
    const newPage = model.page + 1;
    setPageNumber(newPage);
    if (!lastPayload.current) return;
    doSearch({ ...lastPayload.current, pageSize: model.pageSize }, newPage);
  };

  const handleSortModelChange = (sortModel) => {
    setQueryOptions({ sortModel: [...sortModel] });
    if (!lastPayload.current) return;
    doSearch(
      {
        ...lastPayload.current,
        sortField: sortModel[0]?.field || "",
        sortBy: sortModel[0]?.sort || "",
      },
      pageNumber,
    );
  };

  // ── Vertical divider between fields ───────────────────────────────────
  const divider = (
    <Box
      sx={{
        width: "1px",
        height: "22px",
        backgroundColor: "#d0d5dd",
        flexShrink: 0,
        alignSelf: "center",
      }}
    />
  );

  // ── Shared chip sx ─────────────────────────────────────────────────────
  const chipSx = { fontSize: "12px", height: "22px", flexShrink: 0 };

  return (
    <Box
      sx={{
        backgroundColor: "#FBFBFB",
        borderRadius: "12px 0 0 0",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden", // ← page never scrolls
      }}
    >
      {/* ════════════════ Header + Search bar ════════════════ */}
      <Box
        sx={{
          backgroundColor: "#fff",
          borderBottom: "1px solid #E0E4EB",
          px: 2.5,
          pt: 2,
          pb: 1.5,
          flexShrink: 0, // ← always visible, never pushed off screen
        }}
      >
        {/* Title row */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 1.5,
          }}
        >
          <Typography
            sx={{ fontWeight: 700, fontSize: "18px", color: "#1a1a2e" }}
          >
            Find Talent
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Switch
                    checked={isBooleanSearch}
                    onChange={() => setIsBooleanSearch(!isBooleanSearch)}
                    size="small"
                  />
                }
                label={
                  <Typography sx={{ fontSize: "13px", color: "#555" }}>
                    Boolean Search
                  </Typography>
                }
                labelPlacement="start"
                sx={{ mr: 0, gap: "6px" }}
              />
            </FormGroup>
            <CustomWidthTooltip
              TransitionComponent={Zoom}
              title={
                <Box sx={{ p: 0.5 }}>
                  <Typography variant="body2" fontSize="10px" color="#333">
                    Narrow down results with AND (e.g., "Java AND Python").
                  </Typography>
                  <Typography variant="body2" fontSize="10px" color="#333">
                    Broaden with OR.
                  </Typography>
                  <Typography variant="body2" fontSize="10px" color="#333">
                    Exclude with NOT.
                  </Typography>
                  <Typography variant="body2" fontSize="10px" color="#333">
                    Use quotation marks for exact phrases.
                  </Typography>
                </Box>
              }
              arrow
            >
              <IconButton size="small" sx={{ p: 0.25 }}>
                <InfoOutlinedIcon sx={{ fontSize: "17px", color: "#aaa" }} />
              </IconButton>
            </CustomWidthTooltip>
          </Box>
        </Box>

        {/* ════ Search fields — all same fixed height ════ */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            flexWrap: "nowrap",
          }}
        >
          {/* ── Keywords ── flex: 2.5, chips scroll horizontally */}
          <Box sx={{ ...inputBoxSx, flex: 2.5, minWidth: 0 }}>
            <Autocomplete
              multiple
              options={[]}
              value={value}
              size="small"
              inputValue={inputValue}
              onInputChange={(e, newVal) => setInputValue(newVal)}
              onChange={(e, newVal) => {
                setValue(newVal);
                checkAndClearIfAllEmpty(
                  newVal,
                  minimum,
                  maximum,
                  preferredArr,
                  selectedOptions,
                );
              }}
              freeSolo
              disableClearable
              renderTags={(val, getTagProps) =>
                isBooleanSearch ? (
                  <Typography
                    sx={{
                      fontSize: "13px",
                      color: "#333",
                      whiteSpace: "nowrap",
                      flexShrink: 0,
                    }}
                  >
                    {val.join(", ")}
                  </Typography>
                ) : (
                  val.map((option, index) => (
                    <Chip
                      key={index}
                      size="small"
                      label={option}
                      {...getTagProps({ index })}
                      sx={chipSx}
                    />
                  ))
                )
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  variant="standard"
                  placeholder={
                    value.length === 0 && inputValue === ""
                      ? "Keywords: skills, designation, full name, email, phone no..."
                      : ""
                  }
                  InputProps={{ ...params.InputProps, disableUnderline: true }}
                  onBlur={() => {
                    if (inputValue.trim() !== "") {
                      setValue([...value, inputValue.trim()]);
                      setInputValue("");
                    }
                  }}
                  sx={{
                    "& .MuiInputBase-root": { fontSize: "13px", p: 0 },
                    width: "100%",
                  }}
                />
              )}
              sx={autocompleteSx}
            />
          </Box>

          {divider}

          {/* ── Created By — checkbox multi-select, chips scroll horizontally ── */}
          <Box sx={{ ...inputBoxSx, width: "180px", flexShrink: 0 }}>
            <Autocomplete
              multiple
              fullWidth
              size="small"
              value={selectedOptions}
              onChange={(e, val) => {
                setSelectedOptions(val);
                checkAndClearIfAllEmpty(
                  value,
                  minimum,
                  maximum,
                  preferredArr,
                  val,
                );
              }}
              options={candidateList || []}
              getOptionLabel={(option) => option?.name || ""}
              isOptionEqualToValue={(option, val) => option?.id === val?.id}
              disableCloseOnSelect
              disableClearable
              forcePopupIcon
              popupIcon={<KeyboardArrowDownIcon sx={dropdownIconSx} />}
              PopperComponent={CreatedByPopper}
              renderOption={(props, option, { selected }) => (
                <li {...props} style={{ padding: "2px 8px" }}>
                  <Checkbox
                    icon={uncheckedIcon}
                    checkedIcon={checkedIcon}
                    checked={selected}
                    size="small"
                    sx={{ mr: 0.5, p: 0.5 }}
                  />
                  <ListItemText
                    primary={option?.name}
                    primaryTypographyProps={{ fontSize: "13px" }}
                  />
                </li>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder={selectedOptions.length === 0 ? "Created By" : ""}
                  variant="standard"
                  InputProps={{ ...params.InputProps, disableUnderline: true }}
                  sx={{ "& .MuiInputBase-root": { fontSize: "13px", p: 0 } }}
                />
              )}
              renderTags={(val, getTagProps) =>
                val.length <= 1
                  ? val.map((option, index) => (
                      <Chip
                        key={index}
                        size="small"
                        label={option?.name}
                        {...getTagProps({ index })}
                        sx={{ ...chipSx, maxWidth: "120px" }}
                      />
                    ))
                  : [
                      <Chip
                        key={0}
                        size="small"
                        label={val[0]?.name}
                        {...getTagProps({ index: 0 })}
                        sx={{ ...chipSx, maxWidth: "100px" }}
                      />,
                      <Chip
                        key="more"
                        size="small"
                        label={`+${val.length - 1}`}
                        sx={chipSx}
                      />,
                    ]
              }
              ListboxProps={{
                sx: {
                  maxHeight: "220px",
                  "& .MuiAutocomplete-option": { minHeight: "36px" },
                },
              }}
              sx={dropdownAutocompleteSx}
            />
          </Box>

          {divider}

          {/* ── Min Experience ── */}
          <Box sx={{ ...inputBoxSx, width: "118px", flexShrink: 0 }}>
            <TextField
              value={minimum}
              onChange={handleminimumexpreience}
              onFocus={() => setExpError2("")}
              placeholder="Min. Exp"
              size="small"
              variant="standard"
              type="text"
              inputProps={{ min: 0, max: 40 }}
              InputProps={{ disableUnderline: true }}
              error={Boolean(ExpError2)}
              sx={{
                "& .MuiInputBase-root": { fontSize: "13px", px: 0 },
                width: "100%",
              }}
            />
          </Box>

          <Typography sx={{ color: "#999", fontSize: "15px", flexShrink: 0 }}>
            –
          </Typography>

          {/* ── Max Experience ── */}
          <Box sx={{ ...inputBoxSx, width: "118px", flexShrink: 0 }}>
            <TextField
              value={maximum}
              onChange={handlemaximumexpreience}
              onFocus={() => setExpError("")}
              placeholder="Max. Exp"
              size="small"
              variant="standard"
              type="number"
              inputProps={{ min: 0, max: 40 }}
              InputProps={{ disableUnderline: true }}
              error={Boolean(ExpError)}
              sx={{
                "& .MuiInputBase-root": { fontSize: "13px" },
                width: "100%",
              }}
            />
          </Box>

          {divider}

          {/* ── Location — chips scroll horizontally ── */}
          <Box sx={{ ...inputBoxSx, flex: 1, minWidth: 0 }}>
            <Autocomplete
              multiple
              fullWidth
              size="small"
              value={preferredArr}
              onChange={(e, val) => {
                setPreferredArr(val);
                checkAndClearIfAllEmpty(
                  value,
                  minimum,
                  maximum,
                  val,
                  selectedOptions,
                );
              }}
              onInputChange={(e, newVal) => hanldePreferredInputChange(newVal)}
              options={preferredLocation?.map((ele) => ele.name)}
              disableClearable
              forcePopupIcon
              popupIcon={<KeyboardArrowDownIcon sx={dropdownIconSx} />}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder={preferredArr.length === 0 ? "Location" : ""}
                  variant="standard"
                  InputProps={{ ...params.InputProps, disableUnderline: true }}
                  sx={{ "& .MuiInputBase-root": { fontSize: "13px", p: 0 } }}
                />
              )}
              renderTags={(val, getTagProps) =>
                val.length <= 1
                  ? val.map((option, index) => (
                      <Chip
                        key={index}
                        size="small"
                        label={option}
                        {...getTagProps({ index })}
                        sx={chipSx}
                      />
                    ))
                  : [
                      <Chip
                        key={0}
                        size="small"
                        label={val[0]}
                        {...getTagProps({ index: 0 })}
                        sx={chipSx}
                      />,
                      <Chip
                        key="more"
                        size="small"
                        label={`+${val.length - 1} more`}
                        sx={chipSx}
                      />,
                    ]
              }
              sx={dropdownAutocompleteSx}
            />
          </Box>

          {divider}

          {/* ── Search / Clear buttons ── */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              flexShrink: 0,
            }}
          >
            {!isSearchActive ? (
              <Button
                variant="contained"
                onClick={handleSearchCandidate}
                // disabled={!isSearchEnabled}
                sx={{
                  height: `${FIELD_HEIGHT}px`,
                  fontSize: "13px",
                  fontWeight: 700,
                  letterSpacing: "0.5px",
                  textTransform: "uppercase",
                  boxShadow: "none",
                  px: 2,
                  borderRadius: "8px",
                  backgroundColor: "#3F95EA",
                  color: "#fff",
                  "&:hover": {
                    backgroundColor: "#006CB7",
                    boxShadow: "none",
                  },
                  "&.Mui-disabled": {
                    backgroundColor: "#B0BEC5",
                    color: "#fff",
                  },
                }}
              >
                SEARCH
              </Button>
            ) : (
              <>
                <IconButton
                  onClick={handleSearchCandidate}
                  size="small"
                  sx={{
                    width: `${FIELD_HEIGHT}px`,
                    height: `${FIELD_HEIGHT}px`,
                    borderRadius: "8px",
                    backgroundColor: "#3F95EA",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#006CB7" },
                  }}
                >
                  <SearchIcon sx={{ fontSize: "18px" }} />
                </IconButton>
                <IconButton
                  onClick={handleClearSearch}
                  size="small"
                  sx={{
                    width: `${FIELD_HEIGHT}px`,
                    height: `${FIELD_HEIGHT}px`,
                    borderRadius: "8px",
                    border: "1px solid #d0d5dd",
                    backgroundColor: "#fff",
                    color: "#455a64",
                    "&:hover": {
                      backgroundColor: "#fef2f2",
                      borderColor: "#f87171",
                      color: "#ef4444",
                    },
                  }}
                >
                  <CloseIcon sx={{ fontSize: "16px" }} />
                </IconButton>
              </>
            )}
          </Box>
        </Box>

        {/* Inline validation errors */}
        {(ExpError || ExpError2) && (
          <Box sx={{ display: "flex", gap: 3, mt: 0.5 }}>
            {ExpError2 && (
              <Typography sx={{ fontSize: "11px", color: "#d32f2f" }}>
                {ExpError2}
              </Typography>
            )}
            {ExpError && (
              <Typography sx={{ fontSize: "11px", color: "#d32f2f" }}>
                {ExpError}
              </Typography>
            )}
          </Box>
        )}
      </Box>

      {/* ════════════════ Results / Empty state ════════════════ */}
      {/* flex:1 + minHeight:0 → fills remaining space, scrolls inside only */}
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          overflow: "auto",
          backgroundColor: "#fff",
        }}
      >
        {!hasSearched ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
            }}
          >
            <Box
              component="img"
              src="/find-talent-illustration.svg"
              alt=""
              sx={{ width: 110, mb: 2.5, opacity: 0.9 }}
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
            <img src="/assets/Group.svg" alt="" />
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: "17px",
                color: "#1a1a2e",
                my: 1,
              }}
            >
              Smart Talent Search at Your Fingertips
            </Typography>
            <Typography
              sx={{
                fontSize: "13px",
                color: "#aaa",
                textAlign: "center",
                maxWidth: "340px",
                lineHeight: 1.6,
              }}
            >
              Use smart filters and structured data to simplify your hiring and
              discover the right talent.
            </Typography>
          </Box>
        ) : (
          <SearchCandidate searchPayload={currentPayload} />
        )}
      </Box>

      {/* ════════════════ Add to Job Modal ════════════════ */}
      <Modal open={addToJobOpen} onClose={handleCloseAddToJob}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 550,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: 500, p: 2 }}>
            Add to Job
          </Typography>
          <Divider />
          <Box sx={{ p: 2 }}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Select Job
            </Typography>
            <Autocomplete
              value={jobOrder}
              onChange={(event, newValue) => setJobOrder(newValue)}
              inputValue={inputValueJobOrder}
              onInputChange={(event, newInputValue) => {
                const joborderId = newInputValue.split(",").pop().trim();
                setJoborderIds(joborderId);
                setInputValueJobOrder(newInputValue);
              }}
              options={jobOrderOptions.map(
                (opt) => `${opt.title}, ${opt.joborder_id}`,
              )}
              sx={{ mt: 1 }}
              renderInput={(params) => (
                <TextField {...params} label="Job" size="small" />
              )}
            />
            <Box sx={{ mt: 2 }}>
              {shimmer ? (
                <Box display="flex" flexDirection="column" gap={1}>
                  <Skeleton variant="text" width="100%" />
                  <Skeleton variant="rectangular" width={250} height={60} />
                </Box>
              ) : (
                bulkdata.length > 0 && (
                  <Box>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      gutterBottom
                    >
                      {bulkdata.length > 1 ? "These" : "This"} {bulkdata.length}{" "}
                      {bulkdata.length > 1 ? "candidates are" : "candidate is"}{" "}
                      already available in this job. The remaining candidates
                      have been added successfully.
                    </Typography>
                    <Box display="flex" gap={2} flexWrap="wrap">
                      {bulkdata.map((item, i) => (
                        <Box
                          key={i}
                          sx={{
                            backgroundColor: "#FDEDED",
                            p: 1.5,
                            borderRadius: 2,
                            width: 225,
                          }}
                        >
                          <Typography variant="body2" fontWeight={500}>
                            {item.first_name} {item.last_name}
                          </Typography>
                          <Typography variant="caption">
                            {item.email1}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                )
              )}
            </Box>
          </Box>
          <Divider />
          <Box
            sx={{ p: 1.5, display: "flex", justifyContent: "flex-end", gap: 2 }}
          >
            <Button
              className="cancel-btn"
              variant="text"
              size="small"
              onClick={handleCloseAddToJob}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              size="small"
              disabled={adddisbale || !jobOrder}
              onClick={handleAddCandidates}
            >
              Add
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* ════════════════ Snackbar ════════════════ */}
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity={
            snackbarMessage === "Candidate Added Successfully"
              ? "success"
              : "error"
          }
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      {/* ════════════════ Candidate Details panel ════════════════ */}
      <CandidateDetails
        issearchnavbar={true}
        isOpen={isApplicanOpen}
        setApplicanOpen={setApplicanOpen}
        onClose={() => setApplicanOpen(false)}
        selectedRowData={selectedRowData}
      />
    </Box>
  );
};

export default FindTalent;
